import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'utcFormat'
})
export class UtcFormatPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return (value !== null) ? 'UTC' + ((Number(value) >= 0) ? '+' + value : value)  + ':00' : '';
  }

}
